"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.typographyVariantEnum = void 0;
let typographyVariantEnum = exports.typographyVariantEnum = /*#__PURE__*/function (typographyVariantEnum) {
  typographyVariantEnum["title"] = "ds-title";
  typographyVariantEnum["titleSemiBold"] = "ds-title-semi-bold";
  typographyVariantEnum["titleBold"] = "ds-title-bold";
  typographyVariantEnum["headline"] = "ds-headline";
  typographyVariantEnum["headlineSemiBold"] = "ds-headline-semi-bold";
  typographyVariantEnum["headlineBold"] = "ds-headline-bold";
  typographyVariantEnum["subHeadLine"] = "ds-subHeadline";
  typographyVariantEnum["subHeadLineSemiBold"] = "ds-subHeadline-semi-bold";
  typographyVariantEnum["subHeadLineBold"] = "ds-subHeadline-bold";
  typographyVariantEnum["body"] = "ds-body";
  typographyVariantEnum["bodySemiBold"] = "ds-body-semi-bold";
  typographyVariantEnum["bodyBold"] = "ds-body-bold";
  typographyVariantEnum["caption"] = "ds-caption";
  typographyVariantEnum["captionSemiBold"] = "ds-caption-semi-bold";
  typographyVariantEnum["captionBold"] = "ds-caption-bold";
  typographyVariantEnum["label"] = "ds-label";
  typographyVariantEnum["labelSemiBold"] = "ds-label-semi-bold";
  typographyVariantEnum["labelBold"] = "ds-label-bold";
  typographyVariantEnum["span"] = "ds-span";
  typographyVariantEnum["spanSemiBold"] = "ds-span-semi-bold";
  typographyVariantEnum["spanBold"] = "ds-span-bold";
  return typographyVariantEnum;
}({});